var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-1 label-type-answer",class:_vm.classLabel},[_c('aha-icon',{attrs:{"name":_vm.icon,"width":"13","height":"13","viewBox":"0 0 18 18"}}),_c('strong',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }